import { defineStore } from "pinia";

export const useBookingIdStore = defineStore("bookingId", {
  state: () => ({
    bookingId: null as string | null
  }),
  persist: {
    storage: sessionStorage
  },
  actions: {
    setBookingId(id: string | null) {
      this.bookingId = id;
    }
  }
});
